module.exports = __webpack_public_path__ + "static/media/23.759d3da3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/units/23.svg
// module id = 396
// module chunks = 14